import { useEffect, useState, useRef } from "react";
import { getToken, getUserId, getInizioPeriodo, getFinePeriodo } from "../../../auth";
import funzione_collegamento from "../../../funzioni_server/pacchetti_lez_function.js";
import  differenzaOrario  from "../../../funzioni/differenza_ore";
import "../../../stili/tabelle.css";
import "../../../stili/popup.css";
import "../../../stili/tabs.css"
import convertDate from "../../../funzioni/converti_data";
import { DateTime } from 'luxon';
import nome_id from "../../../funzioni/nome_id.js"
import {convertiIdNoleggio,convertiValuta,convertiTipoRiparazione,convertiIdInventario,materialeDisponibile,analisiMateriale,sovrapposti,ordinaPerData,convertiTipoStorage} from "../../../funzioni/funzioni_utili"
import ReactDOM from "react-dom/client";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faUser,
    faUsers,
    faPencil,
    faTrashCan,
    faCircleInfo,
    faSpinner,
    faFileInvoice
} from "@fortawesome/free-solid-svg-icons";
import Lottie from "lottie-react";
import animLoading from "../../../assets/loading.json";
import {noleggi_off,utenti_off} from "../../../offline/offline_costanti.js";
/* global $ */
/* global DevExpress */
function RiparazioniStorico() {
var docfileheader
var docfile
var docfileheader2
var docfile2
var MAX_WIDTH
var MAX_HEIGHT
var QUALITY
const inizioP=DateTime.fromISO(getInizioPeriodo()).toFormat("yyyyMMdd")
const fineP=DateTime.fromISO(getFinePeriodo()).plus({days:1}).toFormat("yyyyMMdd")
function DynamicLessonButton2({ cellInfo, }) {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    $("#loadingOverlay").show();
     setLoading(true);
     console.log(cellInfo)
     if (!cellInfo.data.invoiceid) {
         const content = generaInterfacciaFattura(cellInfo.data)
         $("#fattura").dxPopup("instance").option(
             "title",
             `Fattura`
         );
         $("#fattura").dxPopup("instance").option("contentTemplate", () => content);
         $("#fattura").dxPopup("instance").show();
         $("#fattura").dxPopup("instance").option("toolbarItems", [{
             widget: 'dxButton',
             toolbar: 'bottom',
             location: 'after',
             options: {
                 stylingMode: 'contained',
                 text: 'Salva',
                 onClick: async function () {
                     let intestazioniR = $("#intestazione").dxDataGrid("instance").option("dataSource")[0]
                     delete intestazioniR["__KEY__"]
                     let totalePagato = 0
                     let totale = 0
                     let righe = $("#righe").dxDataGrid("instance").option("dataSource")
                     for (let riga of righe) {
                         totale += riga.invoicerownettotvalue
                         totalePagato += riga.pagato
                     }
                     intestazioniR["invoicedate"] = DateTime.fromISO(intestazioniR["invoicedate"]).toFormat("yyyyMMdd")
                     intestazioniR["invoicenetvalue"] = totale
                     intestazioniR["invoicegrossvalue"] = totale
                     intestazioniR["invoiceadvance"] = totalePagato
                     intestazioniR["invoicetopay"] = totale - totalePagato

                     let richiestaFattura = await funzione_collegamento({
                         userid: getUserId(),
                         token: getToken(),
                         logout_on_error: true,
                         valori: intestazioniR,
                         azione: 'setInvoice'
                     })
                     const idFattura = richiestaFattura.invoiceid
                     let richiestaRiga
                     for (let riga of righe) {
                         delete riga.__KEY__
                         riga["invoiceid"] = idFattura
                         richiestaRiga = await funzione_collegamento({
                             userid: getUserId(),
                             token: getToken(),
                             logout_on_error: true,
                             valori: riga,
                             azione: 'setInvoiceRow'
                         })
                     }
                     const fatturaRich = await funzione_collegamento({
                         userid: getUserId(),
                         token: getToken(),
                         logout_on_error: true,
                         filtri: {getid: idFattura},
                         azione: 'generateInvoice'
                     })
                     if (!$("#bottoneSalva").dxCheckBox("instance").option("value")) {
                         richiestaFattura = await funzione_collegamento({
                             userid: getUserId(),
                             token: getToken(),
                             logout_on_error: true,
                             delId: idFattura,
                             azione: 'delInvoice'
                         })
                     }
                     else{
                         const rich=await funzione_collegamento({
                           userid: getUserId(),
                            token: getToken(),
                            logout_on_error: true,
                            setId:cellInfo.data.repairid,
                            valori: {invoiceid:idFattura},
                            azione:'setRepair'})
                         const dati = await funzione_collegamento({
                        userid: getUserId(),
                        token: getToken(),
                        azione: "getRepairs",
                    })
                    const formattedRows=dati.map((row,index) => ({
                id:index,
                repairid:row.repairid,
                data:convertDate(row.repairdate).toISO({ includeOffset: false }),
                nomeKite:row.repairkitename,
                nomeCliente:row.repairclientname,
                costo:row.repaircost,
                valuta:row.repaircostcurrency,
                note:row.repairnotes,
                repairdamagephoto:row.repairdamagephoto,
                repairphoto:row.repairphoto,
                pagato:row.repairadvance,
                tipoRiparazione:row.repairtype,
                conto:row.billid,
                invoiceid:row.invoiceid,
            }))
                      $("#gridContainerRepairs").dxDataGrid("instance").option("dataSource",formattedRows)

                     }
                     const baseURL = "https://jckite.mogaverocompany.co.ke";
                     const fileURL = fatturaRich.pdffilename ? fatturaRich.pdffilename.startsWith("http")
                         ? fatturaRich.pdffilename
                         : `${baseURL}${fatturaRich.pdffilename.startsWith("/") ? "" : "/"}${fatturaRich.pdffilename}` : "";
                     window.open(fileURL, "_blank");
                 }
             }
         }, {
             widget: 'dxButton',
             toolbar: 'bottom',
             location: 'after',
             options: {
                 text: 'Chiudi',
                 stylingMode: 'outlined',
                 type: 'normal',
                 onClick() {
                     $("#fattura").dxPopup("instance").hide();
                 },
             },
         }],)
         $("#loadingOverlay").hide();
         setLoading(false);
     }
     else{
         const baseURL = "https://jckite.mogaverocompany.co.ke";
         const url1=await funzione_collegamento({
        userid: getUserId(),
        token: getToken(),
        logout_on_error: true,
        filtri:{getid:cellInfo.data.invoiceid},
        azione:'getInvoice'
      });
         const url=url1[0]
         const fileURL = url.invoicepdf?url.invoicepdf.startsWith("http")
            ? url.invoicepdf
            : `${baseURL}${url.invoicepdf.startsWith("/") ? "" : "/"}${url.invoicepdf}`:"";
         window.open(fileURL, "_blank")
     }
  };

  return (
    <BounceIconButton
      icon={loading ? faSpinner : faFileInvoice}
       className={loading ? 'spin-icon' : ''}
      color="#46dbf2"
      onClick={loading ? null : handleClick}
    />
  );
}
function generaInterfacciaFattura(dati){
    const allineamento="center"
    const divGen=document.createElement("div")
    const divSalva=document.createElement("div")
    divSalva.id="bottoneSalva"
    divSalva.style.marginTop="10px"
    divGen.appendChild(divSalva)
    const divIntest=document.createElement("div")
    divIntest.id="intestazione"
    const divRighe=document.createElement("div")
    divRighe.id="righe"
    divGen.appendChild(divIntest)
    divGen.appendChild(divRighe)
    let righe=[]
    righe.push({"invoicerowdescr":`Repair ${dati.nomeKite}`,"pagato":dati.pagato,"invoicerowcurrency":dati.valuta,"invoicerowquant":1,"invoicerownetunitvalue":dati.costo,"invoicerownettotvalue":dati.costo,"invoicerowgrosstotvalue":dati.costo})
    setTimeout(()=> {
        $("#bottoneSalva").dxCheckBox({
            text:"Salva fattura",
            value:false,
        })
        $("#intestazione").dxDataGrid({
            dataSource:[],
            editing: {
                mode: "popup",
                allowUpdating: true,
                allowAdding: true,
                allowDeleting: true,
                useIcons: true,
                popup: {
                    title: "Modifica intestazione",
                    showTitle: true,
                    width: "80%",
                    height: "auto",
                    maxHeight: "90%",
                }
            },
            columns: [
             { dataField: "invoicecustomer", alignment:allineamento,caption: "Nome Fattura",hidingPriority:9},
          {
            dataField: "invoicedate",
            caption: "Data",
            sortOrder: "desc",
            alignment:allineamento,
            editCellTemplate: function (cellElement,cellInfo) {
          if ($("#val_reg_int").length===0) {
                $('<div id="val_reg_int"></div>').appendTo(cellElement)
            }
            $("#val_reg_int").dxDateBox({type:"date",format: "dd/MM/yyyy",displayFormat :"dd/MM/yyyy",value:cellInfo.value, onValueChanged: function(e) {
            if (e.value instanceof Date) {
              cellInfo.setValue(DateTime.fromJSDate(e.value).toISO({includeOffset:false}))
            }
            else {
                cellInfo.setValue(e.value)
            }
            }})
          },
            hidingPriority: 7,
            filterOperations: ["between", "=", "<", ">"],
            calculateFilterExpression: function(filterValue, selectedFilterOperation) {
              if (!filterValue) return null;
              if (selectedFilterOperation === "between" && Array.isArray(filterValue)) {
                const isoStart = DateTime.fromJSDate(filterValue[0]).toISO({ includeOffset: false });
                const isoEnd = DateTime.fromJSDate(filterValue[1]).toISO({ includeOffset: false });
                return [
                  [this.dataField, ">=", isoStart],
                  "and",
                  [this.dataField, "<=", isoEnd]
                ];
              }
              if (selectedFilterOperation === "<") {
                const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
                return [this.dataField, "<=", isoStart]
              }
              if (selectedFilterOperation === ">") {
                const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
                return [this.dataField, ">=", isoStart]
              }
              const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
              return [this.dataField, "=", isoStart]
            },
          customizeText: function(cellInfo) {
            if (typeof cellInfo.value==="string"){
                return DateTime.fromISO(cellInfo.value).toFormat("dd/MM/yyyy");
            }
            else {
                return DateTime.fromISO(DateTime.fromJSDate(cellInfo.value,).toISO({ includeOffset: false })).toFormat("dd/MM/yyyy");
            }
          }
          },
            { dataField: "invoiceaddress", alignment:allineamento,caption: "Indirizzo cliente",hidingPriority:2,
        },
            { dataField: "invoicecontacts", alignment:allineamento,caption: "contatti cliente",hidingPriority:3,
        },
        { dataField: "invoicenotes", alignment:allineamento,caption: "Note fattura",hidingPriority:1,
        },
            { dataField: "invoicenumber", alignment:allineamento,caption: "Numero fattura",hidingPriority:4,
        },
            {dataField:"invoicecurrency",
            visible:false,
          editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_valuta").length===0) {
                $('<div id="val_valuta"></div>').appendTo(cellElement)
            }
            const dati_ut=[{"id":1,"name":convertiValuta(1)},{"id":2,"name":convertiValuta(2)}]
            $("#val_valuta").dxSelectBox({dataSource:dati_ut,value:cellInfo.value,displayExpr:"name",valueExpr:"id", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            }})
          }},

          {
            type: "buttons",
            minWidth:140,
            buttons: [

              {
                hint: "Modifica",
                icon: "none",
                onClick: function (e) {
                  e.component.editRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faPencil}
                      color="#007bff"
                      onClick={() => cellInfo.component.editRow(cellInfo.rowIndex)}
                    />
                  );
                },
              },

              {
                hint: "Elimina",
                icon: "none",
                onClick: function (e) {
                  e.component.deleteRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faTrashCan}
                      color="#dc3545"
                      onClick={() => cellInfo.component.deleteRow(cellInfo.rowIndex)}
                    />
                  );
                },
              },
            ],
          },
          ],
        })
        $("#righe").dxDataGrid({
            dataSource:righe,
            editing: {
                mode: "popup",
                allowUpdating: true,
                allowAdding: true,
                allowDeleting: true,
                useIcons: true,
                popup: {
                    title: "Modifica righe",
                    showTitle: true,
                    width: "80%",
                    height: "auto",
                    maxHeight: "90%",
                }
            },
             columns:[
                {"dataField":"invoicerowdescr","caption":"Descrizione", hidingPriority:5},
                {"dataField":"invoicerowquant",caption:"Quantità",hidingPriority:2,
                editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_quantita_righe").length===0) {
                $('<div id="val_quantita_righe"></div>').appendTo(cellElement)
            }
            $("#val_quantita_righe").dxNumberBox({value:cellInfo.value,minValue:0,onValueChanged: function(e) {
            cellInfo.setValue(e.value)
                    $("#val_netto").dxNumberBox("instance").option("value",$("#val_unitario").dxNumberBox("instance").option("value")*e.value)
            }})
          }
                },
                { dataField: "invoicerowcurrency",visible:false, caption: "Valuta",hidingPriority:5,customizeText: function (e){
          return convertiValuta(e.value)},
          editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_valuta").length===0) {
                $('<div id="val_valuta"></div>').appendTo(cellElement)
            }
            const dati_ut=[{"id":1,"name":convertiValuta(1)},{"id":2,"name":convertiValuta(2)}]
            $("#val_valuta").dxSelectBox({dataSource:dati_ut,value:cellInfo.value,displayExpr:"name",valueExpr:"id", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            $("#val_netto").dxNumberBox("instance").option("format",`#0.##'${convertiValuta(e.value)}'`)
                    $("#val_unitario").dxNumberBox("instance").option("format",`#0.##'${convertiValuta(e.value)}'`)
                    $("#val_gross").dxNumberBox("instance").option("format",`#0.##'${convertiValuta(e.value)}'`)

            }})
          },
        },
                {"dataField":"invoicerownetunitvalue","caption":"Costo unitario",hidingPriority:3,
                cellTemplate: (cellElement, cellInfo) => {
                  if (cellInfo.value!==0){
                    const root = ReactDOM.createRoot(cellElement.get(0));
                    root.render(
                <div style={{ fontFamily: "Poppins, sans-serif" }}>
                    {cellInfo.value.toFixed(2)}{convertiValuta(cellInfo.data.invoicerowcurrency)}
                </div>
            );
          }},
                    editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_unitario").length===0) {
                $('<div id="val_unitario"></div>').appendTo(cellElement)
            }
            $("#val_unitario").dxNumberBox({value:cellInfo.value,minValue:0,format:`#0.##${convertiValuta(cellInfo.data.invoicerowcurrency)}`, onValueChanged: function(e) {
            cellInfo.setValue(e.value)
                    $("#val_netto").dxNumberBox("instance").option("value",$("#val_quantita_righe").dxNumberBox("instance").option("value")*e.value)
            }})
          }
                },
                {"dataField":"invoicerownettotvalue","caption":"Costo netto totale",hidingPriority:4,
                cellTemplate: (cellElement, cellInfo) => {
                  if (cellInfo.value!==0){
                    const root = ReactDOM.createRoot(cellElement.get(0));
                    root.render(
                <div style={{ fontFamily: "Poppins, sans-serif" }}>
                    {cellInfo.value.toFixed(2)}{convertiValuta(cellInfo.data.invoicerowcurrency)}
                </div>
            );
          }},
                    editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_netto").length===0) {
                $('<div id="val_netto"></div>').appendTo(cellElement)
            }
            $("#val_netto").dxNumberBox({value:cellInfo.value,minValue:0,format:`#0.##${convertiValuta(cellInfo.data.invoicerowcurrency)}`, onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            }})
          }
                },

                {"dataField":"pagato","caption":"Pagato",hidingPriority:1,
                cellTemplate: (cellElement, cellInfo) => {
                  if (cellInfo.value!==0){
                    const root = ReactDOM.createRoot(cellElement.get(0));
                    root.render(
                <div style={{ fontFamily: "Poppins, sans-serif" }}>
                    {cellInfo.value.toFixed(2)}{convertiValuta(cellInfo.data.invoicerowcurrency)}
                </div>
            );
          }},
                    editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_pag_in").length===0) {
                $('<div id="val_pag_in"></div>').appendTo(cellElement)
            }
            $("#val_pag_in").dxNumberBox({value:cellInfo.value,minValue:0,format:`#0.##${convertiValuta(cellInfo.data.invoicerowcurrency)}`, onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            }})
          }
                },

            ],
            columnAutoWidth: true,
        columnHidingEnabled: true,
        })

    },0)
    return divGen

}
 function openContoFormPopup(initialData, aggiunta) {
  const popup = $("#popupContoEdit").dxPopup("instance");

  popup.option("contentTemplate", function() {
    const container = $("<div>");
    container.dxForm({
      formData: initialData,
      labelLocation: "top",
      items: [
         {
      dataField: "data",
      label: { text: "Data" },
      template: function(formItem, itemElement) {
        itemElement.empty();

        // Converto il valore iniziale in Date se è ISO:
        let initialValue = formItem.editorOptions?.value || formItem.component.option("formData").data;
        if (typeof initialValue === "string") {
          initialValue = new Date(initialValue);
        }

        $("<div>").appendTo(itemElement).dxDateBox({
          type: "date",
          displayFormat: "dd/MM/yyyy",
          value: initialValue,
          onValueChanged: function(e) {
             const form = formItem.component; // usa il componente passato
    const fd = form.option("formData");
    fd.data = e.value ? e.value.toISOString().slice(0,10) : null;
    form.option("formData", fd);
          }
        });
      }
    },
          { dataField: "nome" },
        { dataField: "note" },

        {
          itemType: "button",
          horizontalAlignment: "right",
          buttonOptions: {
            text: "Salva",
            type: "success",
            onClick: async function() {
              const form = container.dxForm("instance");
              const data = form.option("formData");
              let richiesta;
              const dati= {billcustomer:data.nome,billdate:convertDate(DateTime.fromISO(data.data)),
                billnotes:data.note}
              if (aggiunta){
                   richiesta = await funzione_collegamento({
                       userid: getUserId(),
                        token: getToken(),
                        logout_on_error: true,
                        valori:dati,
                        azione:'setBillItem'
                   })
                  const instance = $("#val_conto").dxLookup("instance");
                    const datas=instance.option("dataSource");
                    datas.push({id:richiesta.billid,text:data.nome})
                  instance.option("dataSource",datas)
              }
              else {
                  richiesta= await funzione_collegamento({
                       userid: getUserId(),
                        token: getToken(),
                        logout_on_error: true,
                        valori:dati,
                      setId:$("#val_conto").dxLookup("instance").option("value"),
                        azione:'setBillItem'
                   })
                    const instance = $("#val_conto").dxLookup("instance");
                    const datas=instance.option("dataSource");
                    datas.find(x => {
                        if (x.id === instance.option("value")) x.text=data.nome
                    })
                  instance.option("dataSource",datas)
              }
              popup.hide();
            }
          }
        }
      ]
    });
    return container;
  });

  popup.show();
}
function BounceIconButton({ icon, onClick, color = "#000" }) {
  const [isClicked, setIsClicked] = useState(false);


  const handleClick = () => {
    setIsClicked(true);
    setTimeout(() => setIsClicked(false), 800);
    onClick();
  };

  return (
    <button
      style={{
        cursor: "pointer",
        padding: "5px",
        background: "none",
        border: "none",
        color: color,
      }}
      onClick={handleClick}
    >
      <FontAwesomeIcon icon={icon} className={isClicked ? "fa-bounce" : ""} />
    </button>
  );
}
function TabellaStoricoRiparazioni() {
    const tipoStorag=[{id:1,text:"Storage"},{id:2,text:"Storage + 3 rescue"},{id:3,text:"Assistenza spiaggia"}]
    const allineamento="center"
    useEffect(() => {
        const fetchStorages = async () => {
            $("#gridContainerRepairs").addClass("grid-container-hidden")
            $("#loadingOverlay").show()
            const dati = await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                filtri:{"repairsfrom":inizioP,"repairsto":fineP},
                azione: "getRepairs",
            })
            const conti = await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                filtri:{"repairsfrom":inizioP,"repairsto":fineP},
                azione: "getBillItems",
            })

            const formattedRows=dati.map((row,index) => ({
                id:index,
                repairid:row.repairid,
                data:convertDate(row.repairdate).toISO({ includeOffset: false }),
                nomeKite:row.repairkitename,
                nomeCliente:row.repairclientname,
                costo:row.repaircost,
                valuta:row.repaircostcurrency,
                note:row.repairnotes,
                repairdamagephoto:row.repairdamagephoto,
                repairphoto:row.repairphoto,
                pagato:row.repairadvance,
                tipoRiparazione:row.repairtype,
                urlPhotoDamage:row.repairdamagephotourl,
                urlPhoto:row.repairphotourl,
                conto:row.billid,
                invoiceid:row.invoiceid,
            }))
            $("#gridContainerRepairs").dxDataGrid({
          dataSource: formattedRows,
        columns: [
          {
            dataField: "data",
            caption: "Data",

            alignment:allineamento,
            editCellTemplate: function (cellElement,cellInfo) {
          if ($("#val_reg").length===0) {
                $('<div id="val_reg"></div>').appendTo(cellElement)
            }
            $("#val_reg").dxDateBox({type:"date",format: "dd/MM/yyyy",displayFormat :"dd/MM/yyyy",value:cellInfo.value, onValueChanged: function(e) {
            if (e.value instanceof Date) {
              cellInfo.setValue(DateTime.fromJSDate(e.value).toISO({includeOffset:false}))
            }
            else {
                cellInfo.setValue(e.value)
            }
            }})
          },
            hidingPriority: 3,
            filterOperations: ["between", "=", "<", ">"],
            calculateFilterExpression: function(filterValue, selectedFilterOperation) {
              if (!filterValue) return null;
              if (selectedFilterOperation === "between" && Array.isArray(filterValue)) {
                const isoStart = DateTime.fromJSDate(filterValue[0]).toISO({ includeOffset: false });
                const isoEnd = DateTime.fromJSDate(filterValue[1]).toISO({ includeOffset: false });
                return [
                  [this.dataField, ">=", isoStart],
                  "and",
                  [this.dataField, "<=", isoEnd]
                ];
              }
              if (selectedFilterOperation === "<") {
                const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
                return [this.dataField, "<=", isoStart]
              }
              if (selectedFilterOperation === ">") {
                const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
                return [this.dataField, ">=", isoStart]
              }
              const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
              return [this.dataField, "=", isoStart]
            },
          customizeText: function(cellInfo) {
            if (typeof cellInfo.value==="string"){
                return DateTime.fromISO(cellInfo.value).toFormat("dd/MM/yyyy");
            }
            else {
                return DateTime.fromISO(DateTime.fromJSDate(cellInfo.value,).toISO({ includeOffset: false })).toFormat("dd/MM/yyyy");
            }
          }
          },
              {
                dataField: "conto",visible:false,
                editCellTemplate: function (cellElement,cellInfo){
            if ($("#val_conto").length===0) {
                $('<div id="val_conto"></div>').appendTo(cellElement)
            }
             let selectBoxData = conti.map(name => ({ id: name.billid, text: name.billcustomer }));

            $("#val_conto").dxLookup({
  dataSource: selectBoxData,
  valueExpr: "id",
  displayExpr: "text",
  value: cellInfo.value,
  searchEnabled: true,
  showClearButton: true,
  placeholder: "Seleziona...",
  onValueChanged: function (e) {
    cellInfo.setValue(e.value);
  },

  // ---> QUI AGGIUNGIAMO I BOTTONI <---
  fieldTemplate: function (selectedItem, container) {
    const valueText = selectedItem ? selectedItem.text : "";

    const wrapper = $("<div>").css({
      display: "flex",
      alignItems: "center",
      width: "100%"
    });

    // Testo del lookup
    $("<span>")
      .text(valueText)
      .css({ flexGrow: 1, overflow: "hidden", textOverflow: "ellipsis" })
      .appendTo(wrapper);

    const instance = $("#val_conto").dxLookup("instance");

    // Funzione helper blocca apertura popup
    const stop = (e) => e.stopPropagation();

    // BTN MODIFICA
    $("<i class='fa-solid fa-pencil' style='cursor:pointer; margin-left:6px;'></i>")
      .on("click", function (e) {
        stop(e);
        const val = instance.option("value");
        if (val) {
          console.log("MODIFICA → id:", val);
          // dentro onClick della matita
const id = instance.option("value");

const conto = conti.find(x => x.billid === id);

openContoFormPopup(
  conto?{nome:conto.billcustomer,data:convertDate(conto.billdate).toISO({includeOffset:false}),
                note:conto.billnotes}: {nome:"",data:convertDate(DateTime.now().toFormat("yyyyMMdd")).toISO({includeOffset:false}),
                note:""},false)
        } else {
          DevExpress.ui.notify("Seleziona un nome per poter modificare!", "error", 1000);
        }
      })
      .appendTo(wrapper);

    // BTN AGGIUNGI
    $("<i class='fa-solid fa-plus' style='cursor:pointer; margin-left:6px;'></i>")
      .on("click", function (e) {
        stop(e);
        console.log("AGGIUNGI → apri popup nuovo");
        openContoFormPopup(
  { nome: "", note:"",data:convertDate(DateTime.now().toFormat("yyyyMMdd")).toISO({includeOffset:false})}, true)
      })
      .appendTo(wrapper);

    // BTN ELIMINA
    $("<i class='fa-solid fa-trash-can' style='cursor:pointer; margin-left:6px;'></i>")
      .on("click", function (e) {
        stop(e);
        const val = instance.option("value");
        if (val) {
          console.log("ELIMINA → id:", val);
          // TUO CODICE QUI
        } else {
          DevExpress.ui.notify("Seleziona un nome per poter eliminare!", "error", 1000);
        }
      })
      .appendTo(wrapper);

    container.empty().append(wrapper);
  }
});

            },
            },
          { dataField: "nomeCliente", caption: "Nome cliente", hidingPriority: 7,alignment:allineamento, },
          { dataField: "nomeKite", caption: "Kite", hidingPriority: 2,alignment:allineamento, },
          { dataField: "tipoRiparazione", caption: "Tipo Riparazione", hidingPriority: 4,alignment:allineamento,
              cellTemplate: function (element, info) {
    element.empty();

    const div = $("<div>").text(convertiTipoRiparazione(info.data.tipoRiparazione));

    if (info.data.urlPhotoDamage) {
        const baseURL = window.location.origin; // es: http://localhost:3000 o https://tuosito.com
        const fileURL = info.data.urlPhotoDamage.startsWith("http")
            ? info.data.urlPhotoDamage
            : `${baseURL}${info.data.urlPhotoDamage.startsWith("/") ? "" : "/"}${info.data.urlPhotoDamage}`;

        const icon = $("<i>")
            .addClass("dx-icon-attach dx-link ml-2")
            .attr("title", "Apri foto danno")
            .css("text-decoration", "none")
            .on("click", function (event) {
                event.stopPropagation();
                window.open(fileURL, "_blank");
            });

        div.append(icon);
    }

    element.append(div);
},

              editCellTemplate: function(cellElement,cellInfo) {
                  if ($("#val_tipo").length===0) {
                      $('<div id="val_tipo"></div>').appendTo(cellElement)
                  }
                  let contatore=1
                  let mappaTipi=[]
                  while (convertiTipoRiparazione(contatore)){
                    mappaTipi.push({id:contatore,text:convertiTipoRiparazione(contatore)})
                    contatore+=1
                  }
                  $("#val_tipo").dxSelectBox({dataSource:mappaTipi,valueExpr: 'id',displayExpr: 'text',value:cellInfo.value,searchEnabled: true, onValueChanged: function(e) {
                    cellInfo.setValue(e.value)
                    },
                  })
              }
          },
          {dataField:"costo",alignment:"center",
            hidingPriority:6,
            cellTemplate: function (element, info) {
    element.empty();

    const div = $("<div>").text(`${info.data.costo.toFixed(2)} ${convertiValuta(info.data.valuta)}`);

    if (info.data.urlPhoto) {
        const baseURL = window.location.origin; // es: http://localhost:3000 o https://tuosito.com
        const fileURL = info.data.urlPhoto.startsWith("http")
            ? info.data.urlPhoto
            : `${baseURL}${info.data.urlPhoto.startsWith("/") ? "" : "/"}${info.data.urlPhoto}`;

        const icon = $("<i>")
            .addClass("dx-icon-attach dx-link ml-2")
            .attr("title", "Apri foto riparazione")
            .css("text-decoration", "none")
            .on("click", function (event) {
                event.stopPropagation();
                window.open(fileURL, "_blank");
            });

        div.append(icon);
    }

    element.append(div);
},
            editCellTemplate:function(cellElement,cellInfo){
                if ($("#vendute_valprezzo").length===0) {
                $('<div id="vendute_valprezzo"></div>').appendTo(cellElement)
            }
            $("#vendute_valprezzo").dxNumberBox({showSpinButtons: true,step:10,min:0,value:cellInfo.value,format:`#0.##'${convertiValuta(cellInfo.data.valuta)}'`, onValueChanged: function(e) {
            cellInfo.setValue(e.value)}
            })}},
            {dataField:"pagato",alignment:"center",hidingPriority:5,

            cellTemplate: (cellElement, cellInfo) => {
                  if (cellInfo.value!==0){
                    const root = ReactDOM.createRoot(cellElement.get(0));
                    root.render(
                <div style={{ fontFamily: "Poppins, sans-serif" }}>
                    {cellInfo.value}{convertiValuta(cellInfo.data.valuta)}
                </div>
            );
          }},
            editCellTemplate:function(cellElement,cellInfo){
                if ($("#vendute_valpagato").length===0) {
                $('<div id="vendute_valpagato"></div>').appendTo(cellElement)
            }
            $("#vendute_valpagato").dxNumberBox({showSpinButtons: true,step:10,min:0,value:cellInfo.value,format:`#0.##'${convertiValuta(cellInfo.data.valuta)}'`, onValueChanged: function(e) {
            cellInfo.setValue(e.value)}
            })}},
            {dataField:"valuta",

            visible:false,
          editCellTemplate: function (cellElement,cellInfo) {
            if ($("#vendute_valvaluta").length===0) {
                $('<div id="vendute_valvaluta"></div>').appendTo(cellElement)
            }
            const dati_ut=[{"id":1,"name":convertiValuta(1)},{"id":2,"name":convertiValuta(2)}]
            $("#vendute_valvaluta").dxSelectBox({dataSource:dati_ut,value:cellInfo.value,displayExpr:"name",valueExpr:"id", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            $("#vendute_valprezzo").dxNumberBox("instance").option("format",`#0.##'${convertiValuta(e.value)}'`)
            $("#vendute_valpagato").dxNumberBox("instance").option("format",`#0.##'${convertiValuta(e.value)}'`)
            }})
          }},
          { dataField: "note", caption: "Note riparazione", hidingPriority: 1,alignment:allineamento, },
          {
                            dataField: 'repairdamagephoto', visible: false,
                            editCellTemplate: function (cellElement, cellInfo) {
                                $('<div id="attachmentcontentdocument" style="display: inline-block;"></div>').appendTo(cellElement);

                                $('<div id="btncleandocument" class="mr-3"></div>').appendTo($('#attachmentcontentdocument'));
                                $('#btncleandocument').dxButton({
                                    text: "",
                                    icon: 'trash',
                                    onClick: function (e) {
                                        $('#lbldocument').text("");
                                        docfileheader = "";
                                        docfile = "";
                                        $('#btncleandocument').addClass("hidden");
                                        $('#fileuploaddocument').val("");

                                        cellInfo.setValue('');
                                    }
                                });

                                if (cellInfo.data.urlPhotoDamage == undefined || cellInfo.data.urlPhotoDamage == null || cellInfo.data.urlPhotoDamage.length == 0)
                                    $('#btncleandocument').addClass("hidden");

                                $('<div id="btnselectdocument" class="mr-3"></div>').appendTo($('#attachmentcontentdocument'));
                                $('#btnselectdocument').dxButton({
                                    text: "",
                                    icon: 'attach',
                                    onClick: function (e) {
                                        $('#fileuploaddocument').trigger('click');
                                    }
                                });

                                $('<input class="hidden" type="file" id="fileuploaddocument" accept="image/*,application/pdf"/>').on('change', function (event) {
                                    if (event.target.files.length > 0) {
                                        var file = event.target.files[0];
                                        if (file.type.startsWith("image")) {
                                            var blobURL = URL.createObjectURL(file);
                                            var img = new Image();
                                            img.src = blobURL;
                                            img.onerror = function () {
                                                URL.revokeObjectURL(this.src);
                                                alert("Unable to load attachment");
                                            };
                                            img.onload = function () {
                                                URL.revokeObjectURL(this.src);

                                                let width = img.width;
                                                let height = img.height;
                                                if (width > height) {
                                                    if (width > MAX_WIDTH) {
                                                        height = Math.round((height * MAX_WIDTH) / width);
                                                        width = MAX_WIDTH;
                                                    }
                                                } else {
                                                    if (height > MAX_HEIGHT) {
                                                        width = Math.round((width * MAX_HEIGHT) / height);
                                                        height = MAX_HEIGHT;
                                                    }
                                                }

                                                var canvas = document.createElement("canvas");
                                                canvas.width = width;
                                                canvas.height = height;
                                                var ctx = canvas.getContext("2d");
                                                ctx.drawImage(img, 0, 0, width, height);

                                                var base64 = canvas.toDataURL(file.type, QUALITY);
                                                docfileheader = base64.substring(0, base64.indexOf(';base64,') + 8);
                                                docfile = base64.substring(base64.indexOf(';base64,') + 8);

                                                cellInfo.setValue(file.name);
                                                $('#lbldocument').text(file.name);
                                                $('#btncleandocument').removeClass("hidden");
                                            }
                                        }
                                        else {
                                            var fileReader = new FileReader();
                                            fileReader.onload = function (fileLoadedEvent) {
                                                var base64 = fileLoadedEvent.target.result;
                                                docfileheader = base64.substring(0, base64.indexOf(';base64,') + 8);
                                                docfile = base64.substring(base64.indexOf(';base64,') + 8);
                                                cellInfo.setValue(file.name);
                                                $('#lbldocument').text(file.name);
                                                $('#btncleandocument').removeClass("hidden");
                                            };
                                            fileReader.readAsDataURL(file);
                                        }
                                    }
                                }).appendTo($('#attachmentcontentdocument'));

                                $('<div id="lbldocument" style="display: inline-block;"></div>').appendTo($('#attachmentcontentdocument'));
                            }
                        },
          {
                            dataField: 'repairphoto', visible: false,
                            editCellTemplate: function (cellElement, cellInfo) {
                                $('<div id="attachmentcontentdocument2" style="display: inline-block;"></div>').appendTo(cellElement);

                                $('<div id="btncleandocument2" class="mr-3"></div>').appendTo($('#attachmentcontentdocument2'));
                                $('#btncleandocument2').dxButton({
                                    text: "",
                                    icon: 'trash',
                                    onClick: function (e) {
                                        $('#lbldocument2').text("");
                                        docfileheader2 = "";
                                        docfile2 = "";
                                        $('#btncleandocument2').addClass("hidden");
                                        $('#fileuploaddocument2').val("");

                                        cellInfo.setValue('');
                                    }
                                });

                                if (cellInfo.data.urlPhoto == undefined || cellInfo.data.urlPhoto == null || cellInfo.data.urlPhoto.length == 0)
                                    $('#btncleandocument2').addClass("hidden");

                                $('<div id="btnselectdocument2" class="mr-3"></div>').appendTo($('#attachmentcontentdocument2'));
                                $('#btnselectdocument2').dxButton({
                                    text: "",
                                    icon: 'attach',
                                    onClick: function (e) {
                                        $('#fileuploaddocument2').trigger('click');
                                    }
                                });

                                $('<input class="hidden" type="file" id="fileuploaddocument2" accept="image/*,application/pdf"/>').on('change', function (event) {
                                    if (event.target.files.length > 0) {
                                        var file = event.target.files[0];
                                        if (file.type.startsWith("image")) {
                                            var blobURL = URL.createObjectURL(file);
                                            var img = new Image();
                                            img.src = blobURL;
                                            img.onerror = function () {
                                                URL.revokeObjectURL(this.src);
                                                alert("Unable to load attachment");
                                            };
                                            img.onload = function () {
                                                URL.revokeObjectURL(this.src);

                                                let width = img.width;
                                                let height = img.height;
                                                if (width > height) {
                                                    if (width > MAX_WIDTH) {
                                                        height = Math.round((height * MAX_WIDTH) / width);
                                                        width = MAX_WIDTH;
                                                    }
                                                } else {
                                                    if (height > MAX_HEIGHT) {
                                                        width = Math.round((width * MAX_HEIGHT) / height);
                                                        height = MAX_HEIGHT;
                                                    }
                                                }

                                                var canvas = document.createElement("canvas");
                                                canvas.width = width;
                                                canvas.height = height;
                                                var ctx = canvas.getContext("2d");
                                                ctx.drawImage(img, 0, 0, width, height);

                                                var base64 = canvas.toDataURL(file.type, QUALITY);
                                                docfileheader2 = base64.substring(0, base64.indexOf(';base64,') + 8);
                                                docfile2 = base64.substring(base64.indexOf(';base64,') + 8);

                                                cellInfo.setValue(file.name);
                                                $('#lbldocument2').text(file.name);
                                                $('#btncleandocument2').removeClass("hidden");
                                            }
                                        }
                                        else {
                                            var fileReader = new FileReader();
                                            fileReader.onload = function (fileLoadedEvent) {
                                                var base64 = fileLoadedEvent.target.result;
                                                docfileheader2 = base64.substring(0, base64.indexOf(';base64,') + 8);
                                                docfile2 = base64.substring(base64.indexOf(';base64,') + 8);
                                                cellInfo.setValue(file.name);
                                                $('#lbldocument2').text(file.name);
                                                $('#btncleandocument2').removeClass("hidden");
                                            };
                                            fileReader.readAsDataURL(file);
                                        }
                                    }
                                }).appendTo($('#attachmentcontentdocument2'));

                                $('<div id="lbldocument2" style="display: inline-block;"></div>').appendTo($('#attachmentcontentdocument2'));
                            }
                        },
          {
            type: "buttons",
            minWidth:120,
            buttons: [
              {
                hint: "Modifica",
                icon: "none",
                onClick: function (e) {
                  e.component.editRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faPencil}
                      color="#007bff"
                      onClick={() => cellInfo.component.editRow(cellInfo.rowIndex)}
                    />
                  );
                },
              },
              {
                hint: "Elimina",
                icon: "none",
                onClick: function (e) {
                  e.component.deleteRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faTrashCan}
                      color="#dc3545"
                      onClick={() => cellInfo.component.deleteRow(cellInfo.rowIndex)}
                    />
                  );
                },
              },
                {
                  hint: "Fattura pacchetto",
                  icon: "none",
                  template: function (cellElement, cellInfo) {
                    const root = ReactDOM.createRoot(cellElement.get(0));
                    root.render(<DynamicLessonButton2 cellInfo={cellInfo} />);
                  },
                },
            ],
          },
          ],
          showBorders: true,
        scrolling:{
        useNative:true
        },
        rowAlternationEnabled: true,
        columnAutoWidth: true,
        paging: { pageSize: 50 },
        height: "100vh",
        width: "100%",
        columnHidingEnabled: true,
        searchPanel: {
          visible: true,
          width: 240,
          placeholder: 'Search...',
        },
        filterRow: {
          visible: true,
          applyFilter: 'auto',
        },
        editing: {
          mode: "popup",
          allowUpdating: true,
          allowAdding: true,
          allowDeleting: true,
          useIcons: true,
          popup: {
            title: "Modifica Riparazione",
            showTitle: true,
            width:"80%",
            height:"auto",
            maxHeight:"90%",
            onShown: function(e) {
                const $content = $(e.component.content());
                $content.wrapInner('<div id="customScroll" style="height: 100%; max"></div>');
                $("#customScroll").dxScrollView({
                    useNative: true,
                    direction: "vertical",
                    showScrollbar: "onScroll"
                });
                }
            },
          form: {
          items: [
              {
                itemType: "group",
                colCount: 2,
                colSpan: 2,
                items: [
                        {
                    dataField: "data",
                    label: { text: "Data" }  // ← Etichetta personalizzata
                  },
                  {
                    dataField: "nomeCliente",
                    label: { text: "Nome cliente" }  // ← Etichetta personalizzata
                  },
                  {
                    dataField: "nomeKite",
                    label: { text: "Nome Kite" }  // ← Etichetta personalizzata
                  },
                  {
                    dataField: "tipoRiparazione",
                    label: { text: "Tipo riparazione" }  // ← Etichetta personalizzata
                  },
                  {
                    dataField: "costo",
                    label: { text: "Costo riparazione" }  // ← Etichetta personalizzata
                  },
                  {
                    dataField: "valuta",
                    label: { text: "Valuta costo" }  // ← Etichetta personalizzata
                  },
                  {
                    dataField: "pagato",
                    label: { text: "Pagato" }  // ← Etichetta personalizzata
                  },
                  {
                    dataField: "repairdamagephoto",
                    label: { text: "Foto danno" }  // ← Etichetta personalizzata
                  },
                  {
                    dataField: "repairphoto",
                    label: { text: "Foto riparazione" }  // ← Etichetta personalizzata
                  },
                  {
                    dataField: "note",
                    label: { text: "Note riparazione" }  // ← Etichetta personalizzata
                  },
                    {
                    dataField: "conto",
                    label: { text: "Conto" }  // ← Etichetta personalizzata
                  },
                ]}
              ]
          }

        },
        onCellClick: function(e) {
            if (e.event.target && e.event.target.classList.contains("dx-datagrid-adaptive-more")) {
              const masterRow = e.component.getRowElement(e.row.rowIndex);
              const $icon = masterRow.find(".dx-datagrid-adaptive-more.custom-icon-expanded");
              if (!($icon.length)) {
              const masterRow = e.component.getRowElement(e.row.rowIndex);
              const $icon = masterRow.find(".dx-datagrid-adaptive-more");
              if ($icon.length){
              $icon[0].className = "dx-datagrid-adaptive-more custom-icon-expanded";}
              }
              else
              {
              $icon[0].className = "dx-datagrid-adaptive-more";
              }}

        },
        onEditorPreparing: function(e) {
          if (e.parentType === "filterRow" && (e.dataField === "data"||e.dataField === "storageDa"||e.dataField==="storageA")) {

            e.editorName = "dxDateBox";  // Forza DateBox come filtro
            e.editorOptions = {
              displayFormat: "dd/MM/yyyy",
              type: "date",
              width: "100%",
              onValueChanged: function(ev) {
                e.setValue(ev.value);  // Applica il filtro
              }
            };
          }
          if (e.parentType === "filterRow" && e.dataField === "tipo") {
            const dataTipo=tipoStorag
            e.editorName = "dxSelectBox";  // Forza DateBox come filtro
            e.editorOptions = {
              dataSource:dataTipo,valueExpr: 'id',displayExpr: 'text',searchEnabled: true,
              width: "100%",
              onValueChanged: function(ev) {
                e.setValue(ev.value);  // Applica il filtro
              }
            };
          }
        },
        onInitNewRow: function (e) {
        e.data.costo=0;
        e.data.pagato=0;
        e.data.sconto=0;
        e.data.data=DateTime.now().toISODate()
        e.data.valuta=1
        e.data.tipoRiparazione=1
        docfileheader=null
        docfile=null
        docfileheader2=null
        docfile2=null
        },
        onEditingStart: function(e){
            docfileheader=null
        docfile=null
        docfileheader2=null
        docfile2=null
        },
        onRowInserting: async function (e) {
            const gridElement = $("#gridContainerRepairs"); // Ottieni l'intera griglia

                // Aggiungi la classe di animazione alla griglia
                gridElement.addClass("table-updated");

                // Rimuovi la classe dopo l'animazione
                setTimeout(() => {
                    gridElement.removeClass("table-updated");
                }, 1000);
            if (docfileheader != null && docfileheader != "") {
                            e.data.repairdamagephoto= docfile;
                            e.data.repairdamagephotoheader= docfileheader;
                            docfileheader = null;
                            docfile = null;
                        }
            if (docfileheader2 != null && docfileheader2 != "") {
                            e.data.repairphoto= docfile2;
                            e.data.repairphotoheader= docfileheader2;
                            docfileheader2 = null;
                            docfile2 = null;
                        }
            const dati_n={"billid":e.data.conto?e.data.conto:0,'repairnotes':e.data.note,'repairclientname':e.data.nomeCliente,'repaircost':e.data.costo,'repaircostcurrency':e.data.valuta,'repairadvance':e.data.pagato,'repairkitename':e.data.nomeKite,"repairdate":convertDate(DateTime.fromISO(e.data.data)),"repairtype":e.data.tipoRiparazione,"repairdamagephoto":e.data.repairdamagephoto,"repairdamagephotoheader":e.data.repairdamagephotoheader,"repairphoto":e.data.repairphotoheader,"repairphotoheader":e.data.repairphotoheader};
            const richiesta = await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                valori:dati_n,
                azione:'setRepair'})
                if (richiesta) {
                    const message = `Riparazione di ${e.data.nomeCliente} aggiunto con successo`;
                    window.DevExpress.ui.notify({message,
                        position: {
                          my: 'center',
                          at: 'center',
                          of: '#gridContainerRepairs',

                        },}, "success", 500);
                    const dati = await funzione_collegamento({
                        userid: getUserId(),
                        token: getToken(),
                        azione: "getRepairs",
                    })
                    const formattedRows=dati.map((row,index) => ({
                id:index,
                repairid:row.repairid,
                data:convertDate(row.repairdate).toISO({ includeOffset: false }),
                nomeKite:row.repairkitename,
                nomeCliente:row.repairclientname,
                costo:row.repaircost,
                valuta:row.repaircostcurrency,
                note:row.repairnotes,
                repairdamagephoto:row.repairdamagephoto,
                repairphoto:row.repairphoto,
                pagato:row.repairadvance,
                tipoRiparazione:row.repairtype,
                conto:row.billid,
                invoiceid:row.invoiceid,
            }))
                      $("#gridContainerRepairs").dxDataGrid("instance").option("dataSource",formattedRows)
                }

        },
        onRowUpdated: async function (e) {
            const gridElement = $("#gridContainerRepairs"); // Ottieni l'intera griglia

                // Aggiungi la classe di animazione alla griglia
                gridElement.addClass("table-updated");

                // Rimuovi la classe dopo l'animazione
                setTimeout(() => {
                    gridElement.removeClass("table-updated");
                }, 1000);
            if (docfileheader != null && docfileheader != "") {
                            e.data.repairdamagephoto= docfile;
                            e.data.repairdamagephotoheader= docfileheader;
                            docfileheader = null;
                            docfile = null;
                        }
            if (docfileheader2 != null && docfileheader2 != "") {
                            e.data.repairphoto=docfile2 ;
                            e.data.repairphotoheader= docfileheader2;
                            docfileheader2 = null;
                            docfile2 = null;
                        }
            const dati_n={"billid":e.data.conto?e.data.conto:0,'repairnotes':e.data.note,'repairclientname':e.data.nomeCliente,'repaircost':e.data.costo,'repaircostcurrency':e.data.valuta,'repairadvance':e.data.pagato,'repairkitename':e.data.nomeKite,"repairdate":convertDate(DateTime.fromISO(e.data.data)),"repairtype":e.data.tipoRiparazione,"repairdamagephoto":e.data.repairdamagephoto,"repairdamagephotoheader":e.data.repairdamagephotoheader,"repairphoto":e.data.repairphotoheader,"repairphotoheader":e.data.repairphotoheader};
            const richiesta = await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                setId:e.data.repairid,
                valori:dati_n,
                azione:'setRepair'})
                if (richiesta) {
                const message = `Riparazione di ${e.data.nomeCliente} modificata con successo`;

                window.DevExpress.ui.notify({message,
                        position: {
                          my: 'center',
                          at: 'center',
                          of: '#gridContainerRepairs',

                        },}, "success", 500);
                }
            },
        onRowRemoving: async function (e) {
            const richiesta=  await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                delId:e.data.repairid,
                azione:'delRepair',
                return_data:false})
            if (richiesta) {
                const message = `Riparazione di ${e.data.nomeCliente} eliminata con successo`;
                window.DevExpress.ui.notify({message,
                position: {
                  my: 'center',
                  at: 'center',
                  of: '#gridContainerRepairs',

                },}, "success", 500);}
        },

        onRowPrepared: function (e) {
            setTimeout(() => {
                $("#gridContainerRepairs").removeClass("grid-container-hidden");
                $("#loadingOverlay").hide();},500)
          if (e.rowType === "data" && e.rowElement && e.data) {
            const parseEuro = (val) =>
              parseFloat(String(val).replace("€", "").replace(",", ".").replace(/\s/g, ""));

            const pagato = parseEuro(e.data.pagato);
            const costo = parseEuro(e.data.costo);
            if ((!isNaN(pagato) && !isNaN(costo) && Math.abs(pagato - costo) > 0.01)) {
              e.rowElement.addClass("row-warning");
              e.rowElement[0].bgColor = "#ffe6e6";
            }
          }
        },
          })
            $("#fattura").dxPopup({
    width: "90%",
    height: 'auto',
    maxHeight:"90%",
    visible: false,
    dragEnabled: true,
 showCloseButton:true,
    onShown: function(e) {
    const $content = $(e.component.content());
    $content.wrapInner('<div id="customScrollFattura" style="height: 100%;"></div>');
    $("#customScrollFattura").dxScrollView({
        useNative: true,
        direction: "vertical",
        showScrollbar: "onScroll"
    });
    },
    });
            $("#popupContoEdit").dxPopup({
  width: "90%",
  height: "auto",
  showTitle: true,
  title: "Gestisci conto",
  dragEnabled: false,
  hideOnOutsideClick: true
});

        }
        fetchStorages()
    },[])
return (<div id="gridContainerRepairs" ></div>)
}

return (<div>
        <TabellaStoricoRiparazioni/>
    <div id="popupContoEdit"></div>
    <div id="fattura"></div>
        <div id="loadingOverlay">
           <div className="spinner">
              <Lottie  style={{ width: "30%", height: "30%" }} animationData={animLoading} loop={true} />
           </div>
        </div>
        </div>)
}

export default RiparazioniStorico